import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-stf-report',
  templateUrl: './stf-report.component.html',
  styleUrls: ['./stf-report.component.scss']
})
export class StfReportComponent implements OnInit {

  constructor(private route: ActivatedRoute, private cryptoJsService: CryptoJsService, private router: Router) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;

  ngOnInit() {
    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        this.autoId = params.autoId;
        this.appId = params.appId;
        this.items = [
          { label: 'Month Wise', routerLink: `/${parentRoute}/report/stf/month-wise`},
          { label: 'District Wise', routerLink: `/${parentRoute}/report/stf/district-wise` },
          { label: 'Vendor Wise',routerLink: `/${parentRoute}/report/stf/vendor-wise` },
          
        ];
      }
      );
  }

}
